import { useEffect } from 'react'

export const FAQ_IMAGE_LEAVE_MESSAGE = '선택한 FAQ 이미지는 저장 전에 이동하면 사라집니다. 이동하시겠습니까?'

export const hasPendingFaqImage = (data = {}) => {
    return data.image instanceof File
}

// 업로드 파일은 브라우저 보안상 다시 채워 넣을 수 없어서, 새로고침/탭 닫기 직전에만 기본 경고를 띄운다.
export const usePendingFaqImageUnloadGuard = (enabled) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !enabled) {
            return undefined
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault()
            event.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [enabled])
}
